import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Button,
  Card,
  CardContent,
  CardHeader,
  Alert,
  Snackbar,
} from '@mui/material';
import ChangePassword from './ChangePassword';

const Settings = () => {
  const [message, setMessage] = useState({ open: false, text: '', severity: 'info' });
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);

  const handleCloseMessage = () => {
    setMessage({ ...message, open: false });
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Settings
      </Typography>

      <Alert severity="info" sx={{ mb: 3 }}>
        Settings configuration is managed through environment variables and configuration files. 
        For production changes, please update your deployment configuration.
      </Alert>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader title="System Information" />
            <CardContent>
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="textSecondary">Hub Version</Typography>
                <Typography variant="body1">1.0.0</Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="textSecondary">API Base URL</Typography>
                <Typography variant="body1" sx={{ fontFamily: 'monospace' }}>
                  {window.location.origin}/api
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" color="textSecondary">Environment</Typography>
                <Typography variant="body1">
                  {process.env.NODE_ENV === 'production' ? 'Production' : 'Development'}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader title="Account Security" />
            <CardContent>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                Keep your account secure by regularly updating your password
              </Typography>
              <Button
                fullWidth
                variant="contained"
                onClick={() => setChangePasswordOpen(true)}
                sx={{ justifyContent: 'flex-start' }}
              >
                🔒 Change Password
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader title="Quick Links" />
            <CardContent>
              <Button
                fullWidth
                variant="outlined"
                href="/install-gateway"
                sx={{ mb: 2, justifyContent: 'flex-start' }}
              >
                Install guide
              </Button>
              <Button
                fullWidth
                variant="outlined"
                href="mailto:info@pomsoft.net"
                sx={{ justifyContent: 'flex-start' }}
              >
                Email info@pomsoft.net
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardHeader title="About EyeSense Hub" />
            <CardContent>
              <Typography variant="body1" paragraph>
                EyeSense Hub is the management site for gateways you install yourself.
                Deer detection runs on the included small model with no GPU.
                A GPU is only for large-vision checks or fine-tuning.
                Questions go to info@pomsoft.net. The install guide is on this site.
              </Typography>
              <Typography variant="body2" color="textSecondary">
                © 2026 EyeSense.ai. All rights reserved.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Snackbar
        open={message.open}
        autoHideDuration={6000}
        onClose={handleCloseMessage}
      >
        <Alert onClose={handleCloseMessage} severity={message.severity}>
          {message.text}
        </Alert>
      </Snackbar>

      <ChangePassword
        open={changePasswordOpen}
        onClose={() => setChangePasswordOpen(false)}
      />
    </Box>
  );
};

export default Settings;
